import { render, staticRenderFns } from "./RecipeIngredientsEdit.vue?vue&type=template&id=077a6ab6&scoped=true&"
import script from "./RecipeIngredientsEdit.vue?vue&type=script&lang=ts&"
export * from "./RecipeIngredientsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeIngredientsEdit.vue?vue&type=style&index=0&id=077a6ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a6ab6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable,VSpacer,VTooltip})
